<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Admission Fee Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="4" md="4">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" return-object :items="ay_list" item-text="ay" label="Select Academic Year" outlined persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="std" item-value="id" :items="std_list" item-text="standard" label="Select Standard" outlined persistent-hint hint="Please Select Standard" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="mode" item-value="id" :items="mode_list" item-text="name" label="Select Payment Mode" outlined persistent-hint hint="Please Select Payment Mode" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="mt-6 button" @click="getReport()">Get Admission Fee Report</v-btn>
                </v-col>
            </v-row>
            <!-- filters to be added -->
            <v-col cols="12" sm="12" md="12">
            <!-- <v-btn color="success" outlined rounded v-if="application_form_list != ''">
                <download-excel class="mr-2 pb-3 pt-2" :data="bookList1" :fields="table_fields" worksheet="AdmissionFeeReport" name="AdmissionFeeReport.xls"> <v-icon dark>mdi-file-excel</v-icon> Export </download-excel>
            </v-btn> -->
             <v-btn
            rounded
            color="success"
             v-if="application_form_list != ''"
            outlined
            @click="fnExcelReport('my-table-id', 'AdmissionFeeReport')"
            :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
          <div id="my-table-id">
            <v-data-table v-if="application_form_list != ''" :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search" @current-items="getFiltered">
                <template v-slot:top class="pb-5">
                    <v-row dense justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete
                                                    class="mr-2 pb-5 pt-2"
                                                    flat
                                                    hide-details
                                                    small
                                                    rounded
                                                    dense
                                                    outlined
                                                    color="#0F2027"
                                                    :label="header.text"
                                                    multiple
                                                    clearable
                                                    :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"
                                                ></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
                <template v-slot:item.is_fees_paid="{ item }">
                    <span v-if="item.is_fees_paid">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
            </v-data-table>
          </div>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                overlay: false,
                search: null,
                std: null,
                std_list: null,
                ay: null,
                ay_list: [],
                mode: null,
                mode_list: [],
                radios: null,
                form_no: null,
                stud_name: null,
                application_form_list: [],
                filterArr: [],
                filters: {
                    form_no: [],
                    name: [],
                },
                headers: [
                    {
                        text: "Sr. No.",
                        align: "left",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Application From No.",
                        align: "left",
                        sortable: false,
                        value: "form_no",
                    },
                    {
                        text: "Student Name",
                        align: "left",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "Amount",
                        align: "left",
                        sortable: false,
                        value: "fee",
                    },
                    {
                        text: "Paid for Standard",
                        align: "left",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Order Id",
                        align: "left",
                        sortable: true,
                        value: "order_id",
                    },
                    {
                        text: "Transaction Id",
                        align: "left",
                        sortable: true,
                        value: "trxn_id",
                    },
                    {
                        text: "Transaction Date",
                        value: "transaction_date",
                        sortable: false,
                    },
                    {
                        text: "Payment Status",
                        value: "transaction_status",
                        sortable: false,
                    },
                ],
                table_fields: {
                    "Sr. No": "srno",
                    "Application From No.": "form_no",
                    "Student Name": "name",
                    Amount: "fee",
                    "Paid for Standard": "standard",
                    "Order Id": "order_id",
                    "Transaction Id": "trxn_id",
                    "Transaction Date": "transaction_date",
                    "Payment Status": "transaction_status",
                },
            };
        },
        methods: {
               fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.application_form_list.map((d) => d[val]);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getReport() {
                const data = {
                    //  radios: this.radios,
                    ay: this.ay.id,
                    //   form: this.form_no,
                    std: this.std,
                    mode: this.mode,
                    //  stud_name: this.stud_name,
                };
                this.overlay = true;
                axios
                    .post("/Admission/getAdmissionFeesReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.application_form_list = res.data.application_form_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            onload() {
                this.overlay = true;
                axios
                    .post("/Admission/getAdmissionFeesReportData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.ay_list = res.data.ay_list;
                            this.std_list = res.data.std_list;
                            this.mode_list = res.data.payment_mode;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
        },
        computed: {
            bookList1() {
                return this.application_form_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    input[type="number"] {
        width: 70%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    
</style>
